var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"spinner-container"},[_c('div',{staticClass:"spinner"},_vm._l((12),function(n){return _c('div',{key:n,staticClass:"bar",style:(_vm.getStyle(n))})}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }